import { useEffect, useState, type RefObject } from 'react';

/**
 * Content-width aware checkout layout.
 * Uses the actual PreviewStep container (after sidebar), not the viewport.
 */
export function useCheckoutColumns(
  containerRef: RefObject<HTMLElement | null>,
  minTwoColWidth = 920,
) {
  const [twoColumn, setTwoColumn] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;

    const measure = () => {
      setTwoColumn(el.clientWidth >= minTwoColWidth);
    };

    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [containerRef, minTwoColWidth]);

  return twoColumn;
}
